// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"style_menuItem__2o4WH","menuItemLabel":"style_menuItemLabel__1nXxr","menuItemIcon":"style_menuItemIcon__2JcAe"};